window.addEventListener('load', function() {
    let swiperOptions = {
        autoplay: {
            delay: 3000,
            disableOnInteraction: false
          }
    };
    
    const AnnouncementSlider = new Swiper('.AnnouncementSlider', swiperOptions);
});